import { connect } from "react-redux";
import SearchMyBooking from "app/pages/Account/SearchMyBooking/SearchMyBooking";
import { bindActionCreators } from "redux";
import { fetchSearchMyBooking } from "app/pages/Account/SearchMyBooking/searchMyBookingActionCreators";
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { isWhiteLabel } from "app/reducers/brandSelector";
import { isAuthenticated } from "app/pages/Auth/authSelectors";

const SearchMyBookingContainer = props => {
	const { fetchSearchMyBooking } = props;
	const handleFormSuccess = useCallback((bookingRef, email) => {
		fetchSearchMyBooking(bookingRef, email);
	}, []);

	return <SearchMyBooking onFormSuccess={handleFormSuccess} {...props} />;
};

const mapStateToProps = state => {
	return {
		isWhiteLabel: isWhiteLabel(state),
		userIsConnected: isAuthenticated(state),
		searchMyBooking: state.searchMyBooking,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({ fetchSearchMyBooking }, dispatch);

SearchMyBookingContainer.propTypes = {
	fetchSearchMyBooking: PropTypes.func,
	isWhiteLabel: PropTypes.bool,
	userIsConnected: PropTypes.bool,
	searchMyBooking: PropTypes.object,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchMyBookingContainer);
